import React, { useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import {ArrowUpRight, ChevronLeft, ChevronRight, Grid} from 'react-feather';

import cams from '../../assets/images/cams-single-service-banner.png';

const MyCamsApp = (props) => {

    // Adding custom class to body 
    useEffect(() => {
        props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    })

    return (
        <Fragment>
            <section id="single-project-wrapper">
                <div className="single-project">
                    <div className="container-fluid">
                        <div className="w-full">
                            <div className="single-project-image">
                                <img className="object-cover h-max w-screen" src={cams} alt="Featured" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="max-w-default w-default px-12 py-28 lg:py-24 md:py-16 sm:py-4 container-wrapper">
                            <div className="single-project-details">
                                <div className='breadcrumbs pb-4'>
                                    <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-work'>Our Work</Link><span>{'>'}</span><Link to='/my-cams-app' className='current'>CAMS</Link></li>
                                </div>
                                <div className="flex lg:flex-row md:flex md:flex-col sm:flex-col single-project-details-wrapper">
                                    <div className="single-project-details-left grid grid-rows-1 grid-cols-2 gap-20">
                                        <div className="details-project-name">
                                            <h3 className="heading5 pb-8">Project Name</h3>
                                            <h1>CAMS</h1>
                                        </div>
                                        <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Social Media / Paid Media</p>
                                        </div>
                                        {/* <div>
                                            <h3 className="heading5 pb-6">Type</h3>
                                            <p>Social Media</p>
                                        </div> */}
                                        {/* <div>
                                            <h3 className="heading5 pb-6">Website</h3>
                                            <p>lorem Ipsum</p>
                                        </div> */}
                                    </div>
                                    <div className="single-project-details-right lg:pt-0 lg:py-16 md:pt-12">
                                        <div>
                                            <h2 className="heading5 pb-8">The Ask</h2>
                                            <p>To establish and amplify digital communication channels for CAMS as a brand and their key products - myCAMS, Recon Dynamix, CAMS NPS</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="single-project-details-images py-16">
                                    <img className="h-full lg:w-12/25 md:w-full md:h-full" src={ServicesImage} alt="Featured" />
                                    <img className="h-full lg:w-12/25 md:w-full md:h-full" src={ServicesImage} alt="Featured" />
                                </div> */}
                                <div className="single-project-body">
                                    <h2 className="heading4 pb-8">
                                        What we did
                                    </h2>
                                    <p><strong>Organic Community Building</strong><br/>Our focussed approach on the brand and product content helped expand the community size of CAMS' online channels - Facebook, Twitter and LinkedIn.</p><br/>
                                    <p><strong>myCAMS</strong><br/>CAMS has always played a pivotal role in enabling rapid scaling of the Mutual Fund industry in India. It launched it's mutual fund management app myCAMS, which allows users to easily invest in mutual funds, track their investments, and manager their portfolio on the go.</p><br/>
                                    <p>Organic by MSL was onboarded to increase app downloads and engagement. We followed a 3 pronged channel approach</p><br/>
                                    <ul>
                                        <li><span>Social Media:</span> which helped us build an informative narrative around the app, complementing our paid media efforts</li>
                                        <li><span>Paid Media:</span> for app downloads and engagement</li>
                                        <li><span>Emailer Marketing:</span> for user retention and engagement</li>
                                    </ul><br/>

                                    <p>The app has now crossed the 5 million download mark and is widely used to manage mutual funds.</p>

                                    <h2 className="heading4 pt-16 pb-8 what-campaign-achived">
                                        What the campaign achieved
                                    </h2>
                                    <div className="results">
                                        <div>
                                            <h1>5 Million+</h1>
                                            <h2>Downloads for myCAMS</h2>
                                        </div>
                                        <div>
                                            <h1>15000+</h1>
                                            <h2>Community growth on Linkedin</h2>
                                        </div>
                                        <div>
                                            <h1>7.6%</h1>
                                            <h2>ER or Linkedin</h2>
                                        </div>
                                        <div>
                                            <h1>2.3%</h1>
                                            <h2>ER or Twitter</h2>
                                        </div>
                                    </div>

                                    <div className="pagination">
                                        <div><Link to='/pfizer-keep-it-real'><ChevronLeft/><span>Previous</span></Link></div>
                                        <div><Link to='/our-work'><Grid/><span>All Projects</span></Link></div>
                                        <div><Link to='/spectra-draw-the-line'><ChevronRight/><span>Next</span></Link>
                                    </div>
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
            <section id='take-next-leap' key='single-project'>
                <div className='take-next-leap'>
                    <div className='take-next-leap__left'>
                        <h1 className="heading4 black">Let’s create <span>impact together.</span></h1>
                    </div>
                    <div className='take-next-leap__right'>
                        <p><Link to='/contact-us'>Contact us today<ArrowUpRight /></Link></p>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
        </Fragment>
    );
};

export default MyCamsApp;